import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },

    tableContainer: {
        backgroundColor: '#ffffff',
    },
})
